import { html } from '../../mixins/katapult-element';
import { CamelCase } from '../../modules/CamelCase';
import '../katapult-elements/katapult-button.js';
import { SnakeCase } from '../../modules/SnakeCase';
import { KatapultEditorTemplate } from './katapult-editor-template';
import '../input-element/input-element.js';

class KatapultEquipmentSpecEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style>
        #specSourceLabel {
          position: absolute;
          top: 0;
          right: 0;
          padding: 1.25em 1em;
          font-style: italic;
          color: var(--primary-text-color-faded);
          background: white;
        }
      </style>

      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes/equipment_type" data="{{equipmentTypes}}">
      </katapult-firebase-worker>

      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/street_light_bracket_spec"
        data="{{streetLightBrackets}}"
      >
      </katapult-firebase-worker>

      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/attributes/[[SnakeCase(_itemData.equipment_type)]]_spec"
        data="{{specs}}"
      >
      </katapult-firebase-worker>

      <template is="dom-if" if="[[itemData.source]]">
        <div id="specSourceLabel">Source: [[itemData.source]]</div>
      </template>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <!-- Equipment Type -->
          <template is="dom-if" if="[[equal(step.id, 'equipment_type')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Equipment Type"
                    attribute_name="equipment_type"
                    hide-attribute-name
                    value="[[_itemData.equipment_type]]"
                    data-path="_itemData.equipment_type"
                    on-value-changed="updateProperty"
                    model="[[equipmentTypeList]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>
          <!-- Equipment Spec -->
          <template is="dom-if" if="[[equal(step.id, 'equipment_spec')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Equipment Spec"
                    attribute_name="equipment_spec"
                    hide-attribute-name
                    value="[[_itemData.equipment_spec]]"
                    data-path="_itemData.equipment_spec"
                    on-value-changed="updateProperty"
                    model="[[specs]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Height -->
          <template is="dom-if" if="[[equal(step.id, 'height')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Height"
                    value="[[_itemData.height]]"
                    data-path="_itemData.height"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Width -->
          <template is="dom-if" if="[[equal(step.id, 'width')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Width"
                    value="[[_itemData.width]]"
                    data-path="_itemData.width"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Depth -->
          <template is="dom-if" if="[[equal(step.id, 'depth')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Depth"
                    value="[[_itemData.depth]]"
                    data-path="_itemData.depth"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Weight -->
          <template is="dom-if" if="[[equal(step.id, 'weight')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Weight"
                    value="[[_itemData.weight]]"
                    data-path="_itemData.weight"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">lbf</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Shape Factor -->
          <template is="dom-if" if="[[equal(step.id, 'shape_factor')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Shape Factor"
                    value="[[_itemData.shape_factor]]"
                    data-path="_itemData.shape_factor"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Horizontal Offset -->
          <template is="dom-if" if="[[equal(step.id, 'horizontal_offset')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Horizontal Offset"
                    value="[[_itemData.horizontal_offset]]"
                    data-path="_itemData.horizontal_offset"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Length -->
          <template is="dom-if" if="[[equal(step.id, 'length')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Length"
                    value="[[_itemData.length]]"
                    data-path="_itemData.length"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Rise -->
          <template is="dom-if" if="[[equal(step.id, 'rise')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Rise"
                    value="[[_itemData.rise]]"
                    data-path="_itemData.rise"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Diameter -->
          <template is="dom-if" if="[[equal(step.id, 'diameter')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Diameter"
                    value="[[_itemData.diameter]]"
                    data-path="_itemData.diameter"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Cross Sectional Area -->
          <template is="dom-if" if="[[equal(step.id, 'cross_sectional_area')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Cross Sectional Area"
                    value="[[_itemData.cross_sectional_area]]"
                    data-path="_itemData.cross_sectional_area"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in²</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Modulus of Elasticity -->
          <template is="dom-if" if="[[equal(step.id, 'modulus_of_elasticity')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Modulus of Elasticity"
                    value="[[_itemData.modulus_of_elasticity]]"
                    data-path="_itemData.modulus_of_elasticity"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">psi</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Rated Breaking Strength -->
          <template is="dom-if" if="[[equal(step.id, 'rated_breaking_strength')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Rated Breaking Strength"
                    value="[[_itemData.rated_breaking_strength]]"
                    data-path="_itemData.rated_breaking_strength"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">lbf</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <<katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      equipmentTypeList: {
        type: Object,
        computed: 'getEquipmentTypeList(equipmentTypes, streetLightBrackets)'
      }
    };
  }

  constructor() {
    super();
    this.computedLabel = {
      dependencies: [{ path: 'equipment_type' }, { path: 'equipment_spec', optional: true }],
      compute: (type, spec) => (type ? `${spec ? `${spec} ` : ''}${CamelCase(type)}` : 'Untitled Equipment Spec')
    };
    this.SnakeCase = SnakeCase;
  }

  ready() {
    super.ready();

    this.isType = (...args) => Array.from(args).includes(this.get('_itemData.equipment_type'));

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'equipment_type',
        title: 'Equipment Type',
        trigger: () => this.get('_itemData.equipment_type') != null
      },
      {
        id: 'equipment_spec',
        title: 'Equipment Spec',
        trigger: () => this.get('_itemData.equipment_spec') != null
      },
      {
        id: 'height',
        title: 'Height',
        trigger: () => this.get('_itemData.height') != null,
        if: () => !this.isType('pushbrace', 'street_light_bracket') || (this.isType('streetlight') && !this.streetLightBrackets)
      },
      {
        id: 'width',
        title: 'Width',
        trigger: () => this.get('_itemData.width') != null,
        if: () => !this.isType('pushbrace', 'street_light_bracket') || (this.isType('streetlight') && !this.streetLightBrackets)
      },
      {
        id: 'depth',
        title: 'Depth',
        trigger: () => this.get('_itemData.depth') != null,
        if: () => !this.isType('pushbrace', 'street_light_bracket') || (this.isType('streetlight') && !this.streetLightBrackets)
      },
      {
        id: 'weight',
        title: 'Weight',
        trigger: () => this.get('_itemData.weight') != null,
        if: () => !this.isType('pushbrace')
      },
      {
        id: 'shape_factor',
        title: 'Shape Factor',
        trigger: () => this.get('_itemData.shape_factor') != null,
        if: () => !this.isType('pushbrace', 'street_light_bracket') || (this.isType('streetlight') && !this.streetLightBrackets)
      },
      {
        id: 'horizontal_offset',
        title: 'Horizontal Offset',
        trigger: () => this.get('_itemData.horizontal_offset') != null,
        if: () => !this.isType('pushbrace', 'street_light_bracket') || (this.isType('streetlight') && !this.streetLightBrackets)
      },
      {
        id: 'length',
        title: 'Length',
        trigger: () => this.get('_itemData.length') != null,
        if: () => this.isType('street_light_bracket')
      },
      {
        id: 'rise',
        title: 'Rise',
        trigger: () => this.get('_itemData.rise') != null,
        if: () => this.isType('street_light_bracket')
      },
      {
        id: 'diameter',
        title: 'Diameter',
        trigger: () => this.get('_itemData.diameter') != null,
        if: () => this.isType('pushbrace')
      },
      {
        id: 'cross_sectional_area',
        title: 'Cross Sectional Area',
        trigger: () => this.get('_itemData.cross_sectional_area') != null,
        if: () => this.isType('pushbrace')
      },
      {
        id: 'modulus_of_elasticity',
        title: 'Modulus of Elasticity',
        trigger: () => this.get('_itemData.modulus_of_elasticity') != null,
        if: () => this.isType('pushbrace')
      },
      {
        id: 'rated_breaking_strength',
        title: 'Rated Breaking Strength',
        trigger: () => this.get('_itemData.rated_breaking_strength') != null,
        if: () => this.isType('pushbrace')
      }
    ]);
  }

  _itemDataChanged(changeRecord) {
    super._itemDataChanged(changeRecord);
    if (changeRecord.path == '_itemData.equipment_type') this.set('_itemData.equipment_spec', null);
  }

  getEquipmentTypeList() {
    // If there is not already a street_light_bracket in eq types, but the spec exists, add it to the picklist.
    let eqTypes = JSON.parse(JSON.stringify(this.equipmentTypes));
    if (
      !Object.values(this.equipmentTypes?.picklists ?? {}).some((picklist) =>
        picklist.find((item) => item.value == 'street_light_bracket')
      ) &&
      this.streetLightBrackets
    ) {
      eqTypes.picklists[Object.keys(this.equipmentTypes.picklists)[0]].push({ value: 'street_light_bracket' });
    }
    return eqTypes;
  }

  beforeSave() {
    this._itemData.source = `Manual Entry - ${katapultAuth.user.email} (${new Date().toLocaleDateString()})`;
  }
}

customElements.define('katapult-equipment-spec-editor', KatapultEquipmentSpecEditor);
